<template>
    <span :class="className">{{ orderStateText }}</span>
</template>

<script setup lang="ts">
    import { OrderState } from "@/data/model/Enums";
    import { trans } from "@/operator/localization/Trans";
    import { computed } from "vue";

    const props = defineProps<{
        orderState: OrderState;
    }>();

    const state = computed(() => OrderState[props.orderState]);
    const orderStateText = computed(() => trans.enums.orderState[state.value]);
    const className = computed(() => `order-state-badge order-state-${state.value.toLowerCase()}`);
</script>
